import { useUser } from "../user.js";
import policy from "../../policies/ClaimCommunicationPolicy.js";

export function useClaimCommunicationPermissions() {
  const { user } = useUser();
  return {
    canViewAny: (claim) => policy.viewAny({ user, claim }),
    canMessageInsurer: (claim) => policy.messageInsurer({ user, claim }),
    canDelete: (communication) => policy.delete({ user, communication }),
    canForward: (communication) => policy.forward({ user, communication }),
    canRemind: (communication) => policy.remind({ user, communication }),
  };
}
